<template>
        <div class="form-input-wrapper">
            <label class="form-label" :for="name"><span>{{label}} {{value}} min</span></label><br>
            <input class="form-input" type="range" min="0" max="60" :id="id" v-model="value" :name="name">
        </div>
</template>

<script>
export default {
    props:["id", "name", "label", 'edit_value'],
    data() {
        return {
            value:0
        }
    },
    methods: {
      setValue(){
        if (this.edit_value != undefined) {
          this.value = this.edit_value;
        }
      }
    },
    mounted() {
      let vm = this;
      vm.$nextTick(function () {
        this.inputType = vm.id;
        setTimeout(this.setValue, 100);
      //   setTimeout(this.prijedlogBrojPredmeta, 1000);
      });
    },
};
</script>